import React from 'react';
import { connect } from 'react-redux';

import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { obterFormandosPeloContrato } from '../actions/FormandoActions';
import { editarCamposContrato } from '../actions/ContratoActions';
import { URL_PAGAMENTO } from '../config/urls';

class DetalhesDistribuicaoOrcamentista extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      showModal: false,
      exibirConteudo: false,
      pedidos: [],
      itensTabela: {
        header: [],
        body: [],
        total: []
      },
      valorLiquidoContrato: 0
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  open () {
    this.setState({ showModal: true });
    this.carregarInfoContrato(this.props.selecionado.id);
    this.getValorLiquidoContrato(this.props.selecionado.id);
  }

  close () {
    this.props.atualizarContrato({
      id: this.props.selecionado.id,
      distribuiuItens: this.props.selecionado.distribuiuItens
    });
    this.setState({ showModal: false, exibirConteudo: false, pedidos: [], itensTabela: { header: [], body: [], total: [] } });
  }

  async carregarInfoContrato(idContrato) {
    await axios.get(`${URL_PAGAMENTO}/administracao/pedidos-contrato/${idContrato}`, {
      headers: {
        "Authorization": "Bearer "+localStorage.getItem("tokenPagamento")}})
      .then(async (response) => {
        this.setState({pedidos: response.data});
        await this.props.obterFormandosPeloContrato(idContrato);
        await this.criarHeaderTabelaItens();
        await this.criarBodyTabelaItens();
        await this.removerConviteDoNome();
        await this.setState({exibirConteudo: true});
      }).catch(() => {
        toast.error("Não foi possível consultar os pagamentos deste contrato!");
      });
  }

  checarHeadersTabelaItens (nome, id, quantidade) {
    let header = this.state.itensTabela.header,
      itemPesquisado = header.find((i) => {return nome === i.produto});
    id = Number(id);
    if (itemPesquisado === undefined || (itemPesquisado !== undefined && itemPesquisado.produto !== nome)) {
      header.push({produto: nome, ids: [id], quantidade: quantidade});
    } else if (itemPesquisado.produto === nome) {
      header.forEach((item) => {
        if (item.produto === nome) {
          item.ids.push(id);
        }
      });
    }
    this.setState({itensTabela: {...this.state.itensTabela, header: header}});
  }

  criarBodyTabelaItens () {
    let { formandos } = this.props,
      { itens } = this.props.selecionado,
      { header } = this.state.itensTabela,
      { pedidos } = this.state,
      total = [];

    header.forEach(() => total.push(0));
    formandos.forEach((formando) => {
      formando.itensTabela = [];
      header.forEach(() => formando.itensTabela.push(0));

      // Buscar pedidos deste formando
      let pedidosFormando = pedidos.find(p => p.id === formando.id);

      if (!pedidosFormando || !pedidosFormando.pedidos) {
        return;
      }

      // Filtrar apenas pedidos válidos (não cancelados)
      let pedidosValidos = pedidosFormando.pedidos.filter(pedido => {
        return pedido.status !== "Pedido cancelado";
      });

      // Contabilizar apenas itens de pedidos válidos
      pedidosValidos.forEach((pedido) => {
        if (!pedido.itens) {
          return;
        }

        pedido.itens.forEach((itemPedido) => {
          let itemContrato = itens.find((i) => { return i.id === itemPedido.itemContrato });

          if (!itemContrato) {
            return;
          }

          header.forEach((produto, j) => {
            if (produto.produto === itemContrato.produto && itemContrato.observacao !== "brinde") {
              formando.itensTabela[j] += itemPedido.quantidade;
              total[j] += itemPedido.quantidade;
            }
          });
        });
      });
    });

    this.setState({itensTabela: {...this.state.itensTabela, body: formandos, total: total}});
  }

  async removerConviteDoNome() {
    let { header } = this.state.itensTabela,
      novoHeader = [];

    for (let i = 0; i < header.length; i++) {
      let item = header[i];
      novoHeader.push(item);
      novoHeader[i].produto = novoHeader[i].produto.replace("Convite ", "");
      novoHeader[i].produto = novoHeader[i].produto.replace("com", "c/");
      novoHeader[i].produto = novoHeader[i].produto.replace("sem", "s/");
      novoHeader[i].produto = novoHeader[i].produto.replace("Aproveitamento", "Aprov.");
    }
    this.setState({itensTabela: {...this.state.itensTabela, header: novoHeader}});
  }

  async criarHeaderTabelaItens () {
    let { itens } = this.props.selecionado;

    for (let i = 0; i < itens.length; i++) {
      let item = itens[i];
      if (item.observacao !== "brinde") {
        await this.checarHeadersTabelaItens(item.produto, item.id, item.quantidade);
      }
    }
  }

  calcularValorTotalDoFormando (idFormando) {
    let { pedidos } = this.state,
      valor = 0,
      formando = pedidos.filter((f) => { return f.id === idFormando })[0];

    if (formando) {
      formando.pedidos.map((pedido) => {
        if (pedido.status === "Pendente" || pedido.status === "Pago" || pedido.status === "Pedido em cancelamento" || pedido.status === "") {
          valor += pedido.cobranca.valor;
        }
      });
    }

    return valor;
  }

  calcularTotalContratoMae () {
    let { itens } = this.props.selecionado,
      valor = 0;

    itens.map((item) => {
      valor += item.quantidade * item.preco;
    });

    return valor;
  }

  calcularTotalItensComprados () {
    let { itens } = this.props.selecionado,
      { itensTabela } = this.state,
      valor = 0;

    itensTabela.header.map((item, i) => {
      let itemSelecionado = itens.filter((i) => { return i.id === item.ids[0] && i.observacao !== "brinde" })[0];

      if (item.ids[0] === itemSelecionado.id) {
        valor += itensTabela.total[i] * itemSelecionado.preco;
      }
    });

    return valor;
  }

  async getValorLiquidoContrato(idContrato) {
    await axios.get(`${URL_PAGAMENTO}/administracao/valor-liquido/${idContrato}`, {
      headers: {
        "Authorization": "Bearer "+localStorage.getItem("tokenPagamento")
      }
    })
      .then(async (response) => {
        this.setState({valorLiquidoContrato: response.data.valorLiquido});
      })
      .catch(() => {
        toast.error("Não foi possível consultar o valor líquido dos pedidos do contrato");
      });
  }

  _renderValorBr (valor) {
    return valor.toLocaleString(undefined, {minimumFractionDigits: 2});
  }

  _renderLabel (valor, mascara = null) {
    let cor = "green",
      texto = "+";

    if (valor > 0) {
      cor = "red";
      texto = "-";
    } else {
      valor *= -1;
    }

    return <label className={`badge bg-${cor}`}>{texto}{mascara ? `R$ ${this._renderValorBr(valor)}` : valor}</label>;
  }

  _renderTabelaProdutos () {
    return (
      <div className="table-responsive">
        <table className="table table-bordered table-hover" id="tabelaResumo">
          <thead>
          <tr>
            <th>#</th>
            <th>Produto</th>
            <th>Qtd. contratada</th>
            <th>Valor unitário</th>
            <th>Valor total contratado</th>
            <th>Qtd. comprada</th>
            <th>Valor total comprado</th>
          </tr>
          </thead>
          <tbody>
          {
            this.state.itensTabela.header.length > 0 ?
              this.state.itensTabela.header.map((item, i) => {
                let valorUnitario = this.props.selecionado.itens.filter((it) => { return it.id === item.ids[0] && it.observacao !== "brinde" })[0].preco;
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{item.produto}</td>
                    <td>{item.quantidade}</td>
                    <td>R$ {this._renderValorBr(valorUnitario)}</td>
                    <td>R$ {this._renderValorBr(valorUnitario * item.quantidade)}</td>
                    <td>
                      <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
                        {this.state.itensTabela.total[i]}
                        {this._renderLabel(item.quantidade - this.state.itensTabela.total[i])}
                      </div>
                    </td>
                    <td>
                      <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
                        {`R$ ${this._renderValorBr(valorUnitario * this.state.itensTabela.total[i])}`}
                        {this._renderLabel((valorUnitario * item.quantidade) - (valorUnitario * this.state.itensTabela.total[i]), "money")}
                      </div>
                    </td>
                  </tr>
                )
              })
              : <tr><td colSpan={2 + this.state.itensTabela.header.length} style={{ textAlign: "center" }}>Não existem formandos cadastrados!</td></tr>
          }
          </tbody>
          {
            this.state.itensTabela.header.length > 0 ?
              <tfoot>
              <tr>
                <td colSpan={4} style={{textAlign: "right"}}><strong>TOTAL</strong></td>
                <td>R$ {this._renderValorBr(this.calcularTotalContratoMae())}</td>
                <td><strong>VALOR BRUTO</strong></td>
                <td>
                  <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
                    R$ {this._renderValorBr(this.calcularTotalItensComprados())}
                    {this._renderLabel(this.calcularTotalContratoMae() - this.calcularTotalItensComprados(), "money")}
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={5}></td>
                <td><strong>DESCONTOS</strong></td>
                <td>R$ {this.calcularTotalItensComprados() > this.state.valorLiquidoContrato ? this._renderValorBr(this.calcularTotalItensComprados() - this.state.valorLiquidoContrato) : 0}</td>
              </tr>
              <tr>
                <td colSpan={5}></td>
                <td><strong>VALOR LÍQUIDO</strong></td>
                <td>R$ {this._renderValorBr(this.state.valorLiquidoContrato)}</td>
              </tr>
              </tfoot>
              : null
          }
        </table>
      </div>
    );
  }

  _renderTabelaFormandos () {
    return (
      <div style={{ marginBottom: 15, height: 400, overflow: "auto" }}>
        <div className="table-responsive fixed">
          <table className="table table-bordered table-hover" id="tabelaDistribuicao">
            <thead>
            <tr>
              <th>#</th>
              <th>Formando</th>
              { this.state.itensTabela.header.map((item, i) => <th key={i}>{item.produto}</th> ) }
              <th>Valor das compras</th>
            </tr>
            </thead>
            <tbody>
            {
              this.state.itensTabela.body.length > 0 ?
                this.state.itensTabela.body.map((formando, i) => {
                  return (
                    <tr key={formando.id}>
                      <td>{i + 1}</td>
                      <td>{formando.nome}</td>
                      { formando.itensTabela.map((item, j) => <td key={j}> {item} </td> )}
                      <td>R$ {this._renderValorBr(this.calcularValorTotalDoFormando(formando.id))}</td>
                    </tr>
                  )
                })
                : <tr><td colSpan={2 + this.state.itensTabela.header.length} style={{ textAlign: "center" }}>Não existem formandos cadastrados!</td></tr>
            }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal show={this.state.showModal} onHide={this.close} dialogClassName="modal-90w">
        <Modal.Header closeButton>
          <Modal.Title>Planilha de compras do contrato {this.props.selecionado ? this.props.selecionado.numero : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            this.state.exibirConteudo ?
              this.state.pedidos.length > 0 ?
                <div id="allStuff">
                  <div className="row">
                    <div className="col-sm-12"><h5>Produtos contratados</h5></div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      {this._renderTabelaProdutos()}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div style={{display: "flex", justifyContent: "space-between"}}>
                        <h5>Formandos</h5>
                        <ReactHTMLTableToExcel
                          className="btn btn-link"
                          table="tabelaDistribuicao"
                          filename={`Planilha de compras - ${this.props.selecionado.numero}`}
                          sheet={`Planilha de compras - ${this.props.selecionado.numero}`}
                          buttonText="Baixar"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      {this._renderTabelaFormandos()}
                    </div>
                  </div>
                </div>
                : <div>Este contrato não possui pedidos registrados!</div>
              : <div><i className="fa fa-spin fa-spinner"></i> Carregando</div>
          }
        </Modal.Body>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    formandos: state.formando.todos
  }
}

export default connect(mapStateToProps, { editarCamposContrato, obterFormandosPeloContrato }, null, { forwardRef: true }) (DetalhesDistribuicaoOrcamentista);



// WEBPACK FOOTER //
// ./src/components/DetalhesDistribuicaoOrcamentista.js